import { configureStore } from "@reduxjs/toolkit";
import { agoraSlice } from "./agora-slice";

const store = configureStore(
    {
        reducer: { agora: agoraSlice.reducer}
    }
);
export const agoraActions = agoraSlice.actions;
export default store;